//import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import Axios from 'axios';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import {unregister as unRegisterServiceWorker} from './registerServiceWorker';
import { attachCloudCoverToken } from './Helpers/apiClient';
//import './CSS/general.css';

// Auto-attach the CloudCoverToken header to every request on the global axios
// singleton (all components use `import Axios from "axios"`), so no call can omit it.
attachCloudCoverToken(Axios);

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <App />
  </BrowserRouter>,
  rootElement);

  unRegisterServiceWorker();

